document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  var drawerCloseBtn = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawerOpenBtn && drawerOpenBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    drawerOpenBtn && drawerOpenBtn.setAttribute('aria-expanded', 'false');
  }
  drawerOpenBtn && drawerOpenBtn.addEventListener('click', function () {
    drawer.hidden ? openDrawer() : closeDrawer();
  });
  drawerCloseBtn && drawerCloseBtn.addEventListener('click', closeDrawer);

  /* ---------- Predictive search drawer ---------- */
  var searchDrawer = document.querySelector('[data-search-drawer]');
  var searchOpenBtn = document.querySelector('[data-search-open]');
  var searchCloseBtn = document.querySelector('[data-search-close]');
  searchOpenBtn && searchOpenBtn.addEventListener('click', function () {
    if (!searchDrawer) return;
    searchDrawer.hidden = false;
    var input = searchDrawer.querySelector('input[type="search"]');
    input && input.focus();
  });
  searchCloseBtn && searchCloseBtn.addEventListener('click', function () {
    searchDrawer && (searchDrawer.hidden = true);
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open], [data-cart-icon]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    cartDrawer && (cartDrawer.hidden = false);
  }
  function closeCartDrawer() {
    cartDrawer && (cartDrawer.hidden = true);
  }
  cartOpenBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });
  cartCloseBtns.forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  /* ---------- Cart helpers (Shopify AJAX Cart API) ---------- */
  function fetchCartFragment() {
    return fetch('/cart?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .catch(function () { return null; });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not add to cart');
        return res.json();
      })
      .then(function (item) {
        refreshCartCount();
        openCartDrawer();
        window.location.reload(); // simplest reliable way to refresh the drawer markup
        return item;
      });
  }

  /* Quick-add buttons on product cards */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      addToCart(variantId, 1)
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

  /* Product page add-to-cart form intercept for buy-now vs add */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    var qtyInput = productForm.querySelector('[data-quantity-input]');

    productForm.querySelectorAll('[data-quantity-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val - 1);
      });
    });
    productForm.querySelectorAll('[data-quantity-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    });

    /* Variant option buttons -> update hidden variant id input */
    var productJsonEl = document.querySelector('[data-product-json]');
    var productData = null;
    try {
      productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    } catch (e) {
      productData = null;
    }

    var selectedOptions = {};
    productForm.querySelectorAll('.product__option').forEach(function (optionEl) {
      var index = optionEl.getAttribute('data-option-index');
      var selectedBtn = optionEl.querySelector('.product__option-value.is-selected');
      selectedOptions[index] = selectedBtn ? selectedBtn.getAttribute('data-option-value') : null;
    });

    function updateSelectedVariant() {
      if (!productData) return;
      var match = productData.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(selectedOptions).every(function (i) {
          return selectedOptions[i] === opts[i];
        });
      });
      if (!match) return;
      var hiddenInput = productForm.querySelector('[data-variant-id-input]');
      hiddenInput && (hiddenInput.value = match.id);

      var addBtn = productForm.querySelector('[data-add-to-cart]');
      var addText = productForm.querySelector('[data-add-to-cart-text]');
      if (addBtn) {
        addBtn.disabled = !match.available;
      }
      if (addText) {
        addText.textContent = match.available
          ? 'Add to Cart — ' + formatMoney(match.price)
          : 'Sold Out';
      }
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'INR' });
    }

    productForm.querySelectorAll('.product__option-value').forEach(function (optionBtn) {
      optionBtn.addEventListener('click', function () {
        var wrapper = optionBtn.closest('.product__option');
        var index = wrapper.getAttribute('data-option-index');
        wrapper.querySelectorAll('.product__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        optionBtn.classList.add('is-selected');
        var label = wrapper.querySelector('[data-selected-value]');
        label && (label.textContent = optionBtn.getAttribute('data-option-value'));
        selectedOptions[index] = optionBtn.getAttribute('data-option-value');
        updateSelectedVariant();
      });
    });

    productForm.addEventListener('submit', function (e) {
      var isCheckout = e.submitter && e.submitter.name === 'checkout';
      if (isCheckout) return; // let it submit normally to /cart -> checkout
      e.preventDefault();
      var variantIdInput = productForm.querySelector('[data-variant-id-input]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var addBtn = productForm.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.disabled = true;
      addToCart(variantIdInput.value, qty).catch(function () {
        addBtn && (addBtn.disabled = false);
      });
    });
  }

  /* ---------- Cart page & cart drawer quantity controls ---------- */
  function changeLineQuantity(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function () {
      window.location.reload();
    });
  }

  document.querySelectorAll('[data-quantity-increase][data-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var input = document.querySelector('[data-cart-quantity-input][data-line="' + line + '"], [data-quantity-value][data-line="' + line + '"]');
      var current = input ? parseInt(input.value || input.textContent, 10) : 1;
      changeLineQuantity(line, current + 1);
    });
  });
  document.querySelectorAll('[data-quantity-decrease][data-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var input = document.querySelector('[data-cart-quantity-input][data-line="' + line + '"], [data-quantity-value][data-line="' + line + '"]');
      var current = input ? parseInt(input.value || input.textContent, 10) : 1;
      changeLineQuantity(line, Math.max(0, current - 1));
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = parseInt(btn.getAttribute('data-line'), 10);
      changeLineQuantity(line, 0);
    });
  });
});
